/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

interface ILabelProps {
    className: string;
    label?: string;
}

export const Label: React.FC<ILabelProps> = ({ className, label }) => <span className={className}>{label}</span>;

export default Label;
